/* eslint-disable react-hooks/exhaustive-deps */
import ReactPaginate from "react-paginate";
import React, { useLayoutEffect, useState, useRef, useEffect } from "react";
import SwipeableViews from "react-swipeable-views";

export default function ProductPaginate({
  items,
  totalItems,
  onPageChange,
  ...props
}) {
  const [itemPerpage, setItemPerpage] = useState(12);
  const [currentPage, setCurrentPage] = useState(1);
  const previousItemPerPage = useRef(itemPerpage);
  const resizeTimeoutRef = useRef(null);
  const contentRef = useRef(null);

  const totalItemCount = totalItems || (items ? items.length : 0);
  const pageCount = Math.ceil(totalItemCount / Math.max(1, itemPerpage));

  const getItemsperpage = () => {
    let el = document.getElementById("productContent");
    let el2 =
      document.getElementById("content") || document.getElementById("foodlist");

    if (el) {
      const bound = el.getBoundingClientRect();
      let height = window.innerHeight - 300;

      if (el2) {
        const bound2 = el2.getBoundingClientRect();
        height = bound2.height - 300;
      }

      var item = Math.floor(bound.width / 154) * Math.floor(height / 179);
      if (item < 1) {
        item = 1;
      }

      if (item !== previousItemPerPage.current) {
        previousItemPerPage.current = item;
        setItemPerpage(item);
      }
    }
  };

  const handleResize = () => {
    if (resizeTimeoutRef.current) {
      clearTimeout(resizeTimeoutRef.current);
    }

    resizeTimeoutRef.current = setTimeout(() => {
      getItemsperpage();
    }, 150);
  };

  useLayoutEffect(() => {
    window.addEventListener("resize", handleResize);
    getItemsperpage();

    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    getItemsperpage();
  }, []);

  useEffect(() => {
    if (currentPage > pageCount && pageCount > 0) {
      setCurrentPage(pageCount);
    }
  }, [itemPerpage, pageCount]);

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setCurrentPage(newPage);

    if (onPageChange) {
      onPageChange(newPage);
    }
  };

  const handleMenuSlide = (page) => {
    setCurrentPage(page + 1);

    if (onPageChange) {
      onPageChange(page + 1);
    }
  };

  const handleImageError = (e) => {
    e.target.onerror = null;
    e.target.src = "/images/img-default.jpeg";
  };

  return (
    <>
      <div
        className="mb-auto"
        id="productContent"
        ref={contentRef}
        style={{ height: "calc(100vh - 230px)" }}
      >
        <SwipeableViews
          index={currentPage - 1}
          onChangeIndex={handleMenuSlide}
          enableMouseEvents
        >
          {[...Array(pageCount).keys()].map((pi) => (
            <div
              key={`food-card-page-${pi}`}
              className="row gx-2 overflow-y-hidden overflow-x-hidden"
              style={{ width: "100%", height: "calc(99vh - 210px)" }}
            >
              {items &&
                items
                  .slice(pi * itemPerpage, pi * itemPerpage + itemPerpage)
                  .map((item, index) => (
                    <div
                      className="col-auto"
                      key={`product-${item.productID || index}`}
                    >
                      <button
                        type="button"
                        className="btn btn-link p-0 text-decoration-none"
                        onClick={() => props.handleoptionShow(item)}
                      >
                        <div className="card card-food">
                          <img
                            src={item.productImage}
                            className="food-img"
                            alt={item.productName}
                            onError={handleImageError}
                          />
                          <div className="card-body">
                            <div className="card-name">{item.productName}</div>
                            <div className="text-center tc-4 fs-14">
                              ฿
                              {typeof item.productPrice === "number"
                                ? item.productPrice.toLocaleString()
                                : parseFloat(
                                    item.productPrice
                                  ).toLocaleString()}
                              .-
                            </div>
                          </div>
                        </div>
                      </button>
                    </div>
                  ))}
            </div>
          ))}
        </SwipeableViews>
      </div>

      <div className="d-flex justify-content-center position-relative mt-2">
        <div className="paginationjs-nav J-paginationjs-nav">
          ทั้งหมด {totalItemCount} รายการ
        </div>
        <div className="position-relative">
          <div className="position-absolute fs-12 text-center w-100 pt-1">
            หน้าที่ {currentPage || 1}
          </div>
          <ReactPaginate
            breakLabel="..."
            nextLabel=""
            onPageChange={handlePageClick}
            pageRangeDisplayed={2}
            marginPagesDisplayed={1}
            pageCount={Math.max(1, pageCount)}
            previousLabel=""
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
            forcePage={(currentPage || 1) - 1}
          />
        </div>
      </div>
    </>
  );
}
